import { useTranslation } from "react-i18next";
import React from "react";
import { Button } from "antd";
import { convertMinutesToTimeString } from "../../../../utils/format";
import { RefreshIcon } from "../../../../components/icons/svg";

interface PauseScreencreenProps {
  timeTraining?: number;
  timeDeadline?: number | string;
  type?: "userFinish" | "timeFinish";
  onRetrain?: (v?: any) => void;
  onViewResult?: () => void;
}
function FinishScreen({
  timeTraining = 1000,
  type = "timeFinish",
  onRetrain,
  onViewResult = () => {},
}: PauseScreencreenProps) {
  const { t } = useTranslation();
  return (
    <div className="pause-screen">
      <div className="center flex-column content-center">
        {type === "userFinish" ? (
          <span className="font-weight-6 font-size-16 mb-1">
            {t("Chúc mừng bạn đã nộp bài thành công!", "Chúc mừng bạn đã nộp bài thành công!")}
          </span>
        ) : (
          <span className="font-weight-6 font-size-16 mb-1 text-danger">
            {t("Thời gian làm bài đã kết thúc!", "Thời gian làm bài đã kết thúc!")}
          </span>
        )}

        <p className="font-size-16">
          {t("Tổng thời gian làm bài:", "Tổng thời gian làm bài:")}{" "}
          <span className="text-primary-violet">
            {convertMinutesToTimeString(timeTraining)}
          </span>
        </p>
        <p className="font-size-16">
          {t("Thời gian nộp bài:", "Thời gian nộp bài:")}{" "}
          <span className="text-primary-violet">00:00:00 - 15/05/2024</span>
        </p>
      </div>
      <div className="center gap-8 btn-group">
        <Button
          icon={<RefreshIcon />}
          className="h-40 mt-2 center"
          onClick={onRetrain}
        >
          {t("Làm lại", "Làm lại")}
        </Button>
        <Button className="btn-primary background-violet border-violet h-40 mt-2" onClick={onViewResult}>
          {t("Kiểm tra kết quả", "Kiểm tra kết quả")}
        </Button>
      </div>
    </div>
  );
}

export default FinishScreen;
